<div [class]="skinName">
  <div (click)="selectPlan(plan)">
    <!-- <div *ngIf="(plan?.discount_message || plan.selected_plan)" [ngClass]="(plan.popular_status == 1) ? 'plan-color-btn': 'plan-red-btn'" id="plan-discount">
  {{plan.selected_plan ? selectedText: plan?.discount_message }}</div> -->
  @if ((plan?.discount_message || plan.selected_plan)) {
    <span [ngClass]="(plan.popular_status == 1) ? 'plan-color-btn': 'plan-red-btn'" id="plan-discount">{{plan?.discount_message }}</span>
  }
  <div class="plan-bar">
    <div class="plan-column">
      <div id="plan-title">
        <span>{{plan?.title}}</span>
        <!-- @if ((plan?.discount_message || plan.selected_plan)) {
          <span [ngClass]="(plan.popular_status == 1) ? 'plan-color-btn': 'plan-red-btn'" id="plan-discount">{{plan?.discount_message }}</span>
        } -->
      </div>
      <div class="offer-title">{{plan?.description}}</div>
    </div>
    <div class="price-column">
      <!-- <span id="discount-price" *ngIf="plan?.original_plan_detail && plan?.coupon_mapped && plan?.amount != plan?.original_amount">{{plan?.original_plan_detail}}</span> -->
      @if (plan?.pre_discounted_original_amount > 0) {
        <span id="discount-price">
          <span class="amount">{{plan?.pre_discounted_amount}}</span>
          <span class="months">{{plan?.plan_detail}}</span>
        </span>
      }
      <span id="plan-price">
        <span class="amount">{{plan?.amount}}</span>
        <span class="months">{{plan?.plan_detail}}</span>
      </span>
    </div>
  </div>
  <!-- <div id="plan-title">{{plan?.title}}</div>
  <div id="plan-price">{{plan?.plan_detail}}</div> -->
  <!-- <div id="discount-price" *ngIf="plan?.original_plan_detail && plan?.coupon_mapped">{{plan?.original_plan_detail}}</div> -->
  <!-- <div [ngClass]="(selectedPlan && selectedPlan.subscription_id == plan.subscription_id) ? 'plan-color-btn': 'plan-color-font'" id="plan-detail">{{plan?.subscription_text}}</div> -->
</div>

</div>